import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { AppLoader } from '@hero/components/atoms';
import {
  SendGiftWithContactSendEmail,
  SendGiftWithContactTable,
  SendGiftWithoutContact
} from '@hero/components/organisms/SendGift/Confirmation';
import { CONTACT_TYPE } from '@hero/constants';
import { PageLayout } from '@hero/layouts';
import { useGetRecognition } from '@hero/services';

const confirmationTypes = {
  withContactSendEmail: SendGiftWithContactSendEmail,
  withContactTable: SendGiftWithContactTable,
  withoutContact: SendGiftWithoutContact
};

function SendGiftConfirmationTemplate() {
  const { t } = useTranslation();
  const { recognitionCode } = useParams();

  const { data: recognition, isLoading } = useGetRecognition({ recognitionCode });

  const confirmationType = useMemo(() => {
    return recognition?.contacts?.type === CONTACT_TYPE.list
      ? recognition.experienceSettings?.sharingMethod?.type?.includes?.('email')
        ? 'withContactSendEmail'
        : 'withContactTable'
      : 'withoutContact';
  }, [recognition]);

  const ConfirmationComponent = confirmationTypes[confirmationType];

  return (
    <PageLayout
      header={{
        title: t('sendGift'),
        backButton: true
      }}
    >
      {isLoading ? <AppLoader /> : <ConfirmationComponent />}
    </PageLayout>
  );
}

export { SendGiftConfirmationTemplate };
